// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"sun-fall"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M3 14H2M5.63679 7.63484L4.92969 6.92773M12 4V5M19.0704 6.92773L18.3633 7.63484M22 14H21M7 14C7 11.2386 9.23858 9 12 9C14.7614 9 17 11.2386 17 14","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M2 18H9L12 20L15 18H22","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const SunFallIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'sun-fall',
    ref,
    icon: element,
  },
));

SunFallIcon.displayName = 'SunFallIcon';

export default SunFallIcon;
